module.exports = __webpack_public_path__ + "static/media/polonium_network_event_placeholder_14.51bd36fc.png";